<template>
  <section class="section-block">
    <!-- v-if, if header is not needed do not print it -->
    <div v-if="header" class="section-block__top">
      <h2 class="section-block__header">
        {{ header }}
      </h2>
    </div>

    <div class="grid grid--four">
      <div v-for="(category, i) of categoryList" :key="`${categoryList[i].name}-${i}`" class="category-list">
        <a
          v-for="item of category"
          :key="item.id"
          :href="item.url"
          class="navigational-item navigational-item--arrow navigational-item--white category-list__item">{{ item.name }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    categoryList: {
      type: Array,
      required: true
    },
    header: {
      type: String,
      required: true,
      default: ''
    }
  }
}
</script>
